import { createSelector } from '@reduxjs/toolkit';

import { LayoutModel, Project } from '@paragon/contract-library';
import { getLayoutModels } from '@paragon/layout-models';

import { RootState } from '..';

export const getProjectLayoutModel = createSelector(
  getLayoutModels,
  (state: RootState) => state.application.openContext,
  (state: RootState) => state.sharedComponentSet.sharedComponentSet,
  (layoutModels, openContext, sharedComponentSet): (Project & LayoutModel) | null => {
    if (openContext?.type === 'project') {
      return layoutModels.find((model) => model.guid === openContext.projectGuid) as any;
    }

    if (openContext?.type === 'shared-component-set' && sharedComponentSet && sharedComponentSet.sourceProjectGuid) {
      return layoutModels.find((model) => model.guid === sharedComponentSet.sourceProjectGuid) as any;
    }

    return null;
  },
);
